import Component from '@glimmer/component';

import DropdownListButton from 'rise-ui/components/dropdown-list-button.gjs';

import fnx from 'rise-ui/helpers/fnx.js';
import nom from 'rise-ui/helpers/nom.js';
import one from 'rise-ui/helpers/one.js';
import string from 'rise-ui/helpers/string.js';

export default class TimeSeriesSelectionDateDropdownComponent extends Component {
  <template>
    {{#let
      (one @linkToClear @clearOption true)
      (one @linkToCopy @copyOption true)
      (one @linkToAll @allOption false)
      (one @title "Add Dates")
      as | clearOption copyOption allOption title |
    }}
    <DropdownListButton
      class="qa-ts-ddd"
      @layer={{@layer}}
      @type="small primary"
      @side="bottom-end"
      @title={{title}}
      @onOpen={{fnx @onOpen}}
      @onSelection={{fnx @onSelection}}
      ...attributes
      as | ddlb |
    >
      {{~#if clearOption~}}
        <ddlb.link @key="clear" @route={{@linkToClear}}>Clear Dates</ddlb.link>
      {{~/if~}}
      {{~#if copyOption~}}
        <ddlb.link @key="copy" @route={{@linkToCopy}}>{{string "copy-default-dates"}}</ddlb.link>
      {{~/if~}}
      <ddlb.link @key="week" @route={{@linkToWeek}}>Last Week</ddlb.link>{{nom~}}
      <ddlb.link @key="month" @route={{@linkToMonth}}>Last Month</ddlb.link>{{nom~}}
      <ddlb.link @key="year" @route={{@linkToYear}}>Last Year</ddlb.link>{{nom~}}
      <ddlb.link @key="decade" @route={{@linkTo10Years}}>Last 10 Years</ddlb.link>{{nom~}}
      {{~#if allOption}}
        <ddlb.link @key="all" @route={{@linkToAll}}>All Available</ddlb.link>{{nom~}}
      {{~/if~}}
      <ddlb.button>{{yield to="button"}}</ddlb.button>{{nom~}}
    </DropdownListButton>
    {{/let}}
  </template>
}
